exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* .MuiDataGrid-cellContent {\n  transition: all 300ms linear;\n}\n\n.MuiDataGrid-cellContent:hover {\n  color: lightgray;\n  transition: all 300ms linear;\n} */\n\n.se--intervention-annotation {\n  font-size: 10px;\n}\n", ""]);

